import { AccountActions, AccountState } from "./types";
import { ActionType } from "../types";

const initialState: AccountState = {
  isAuthenticated: false,
  profile: {
    id: "",
    name: "",
    email: "",
    phone_number: "",
    is_verified: false,
    created_at: "",
  },
};

const accountReducer = (
  state: AccountState = initialState,
  action: ActionType
): AccountState => {
  switch (action.type) {
    case AccountActions.UPDATE_IS_AUTHENTICATED: {
      return {
        ...state,
        isAuthenticated: action.payload,
      };
    }
    case AccountActions.UPDATE_PROFILE: {
      return {
        ...state,
        profile: action.payload,
      };
    }
    case AccountActions.CLEAR_PROFILE: {
      return initialState;
    }
    default: {
      return state;
    }
  }
};

export default accountReducer;
